/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { z } from 'zod';

import { translationKey } from '@change-corgi/core/i18n';

import type { PetitionEditPageData, PetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';

import { GEO_REACH_VALUES } from './scope';

type FormStateLocation = PetitionEditPageState['formState']['relevantLocation'];

export const locationSchema = z
	.object({
		localizedName: z.string().optional(),
		googlePlacesId: z.string().optional(),
		geoReach: z.enum(GEO_REACH_VALUES).optional(),
	})
	.refine(
		(val) => {
			switch (val.geoReach) {
				case 'local': {
					return val.localizedName && val.googlePlacesId;
				}
				default: {
					return true;
				}
			}
		},
		{ message: translationKey('corgi.petition.edit.petition_data.location.required_error') as unknown as string },
	);

export const deserializeLocation = ({ petition }: Pick<PetitionEditPageData, 'petition'>): FormStateLocation => {
	if (!petition.relevantLocationLocalizedName || !petition.googlePlacesId) {
		return {
			value: { geoReach: petition.geoReach ?? undefined },
			error: null,
			dirty: false,
		};
	}

	return {
		value: {
			localizedName: petition.relevantLocationLocalizedName,
			googlePlacesId: petition.googlePlacesId,
			geoReach: petition.geoReach ?? undefined,
		},
		error: null,
		dirty: false,
	};
};

// needed to remove geoReach from location object
export const serializeLocation = (location: z.infer<typeof locationSchema>) => {
	if (location.geoReach !== 'local') return null;

	return {
		localizedName: location.localizedName,
		googlePlacesId: location.googlePlacesId,
	};
};
